import { Controller } from '@hotwired/stimulus';

const MOBILE_BREAKPOINT = 768;

function applyBottomPadding(form) {
  const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
  form.style.paddingBottom = isMobile ? '100px' : '120px';
}

export default class extends Controller {
  static values = {
    enabled: { type: Boolean, default: false },
  };

  connect() {
    if (!this.enabledValue) return;

    this.form = this.element;
    this.saveContainer = document.querySelector('.floating-save-container');

    if (!this.saveContainer) {
      console.warn('[NeedySaveBar] Floating save container not found');
      return;
    }

    applyBottomPadding(this.form);

    this.handleResize = this.handleResize.bind(this);
    window.addEventListener('resize', this.handleResize);
  }

  disconnect() {
    if (this.form) {
      this.form.style.paddingBottom = '';
    }
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    if (this.saveContainer) {
      applyBottomPadding(this.form);
    }
  }
}
